/**
 * 2020/4/2 - 15:03
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 *
 */
import Vue from 'vue'
import getVuexWithNameSpace from '../utils/storeHelper'

const { mapState } = getVuexWithNameSpace('app')

const mixin = {
  computed: {
    ...mapState([
      'dataMap'
    ])
  }
}

Vue.mixin(mixin)
